import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { Spinner } from 'reactstrap';
import { LOADING_TYPES } from '@/shared/config';
import useLoadingPage from './useLoadingPage';
import '@/shared/ui/components/Loadings/styles.scss';

/**
 * Covers the report page with the loading indicator matching the current background job. Renders a full screen spinner during initial load, suppresses itself while a clinic report generates unless the AI process is stopping, and otherwise shows either the generating report notice or the plain loading text.
 *
 * @returns The rendered loading overlay, or null when nothing needs one.
 */
const LoadingPage = () => {
  const {
    isLoadingInitial,
    loadingText,
    isGeneratingClinicReport,
    isGeneratingAirpReport,
    isGeneratingReport,
  } = useLoadingPage();

  if (isLoadingInitial) {
    return (
      <div className="loading-propagate">
        <div className="sweet-loading">
          <Spin
            indicator={
              <LoadingOutlined
                style={{
                  color: '#fff',
                  fontSize: 80,
                }}
                spin
              />
            }
          />
        </div>
      </div>
    );
  }

  // Show LoadingPage for AIRP reports or other loading types
  if (isGeneratingClinicReport && loadingText !== LOADING_TYPES.STOPPING_AI_PROCESS) {
    return null;
  }

  // Show loading only if there's loadingText or AIRP report is rendering
  if (!loadingText && !isGeneratingAirpReport) {
    return null;
  }

  return (
    <div className="loading-page-background">
      <div className="loading-page-container">
        <Spinner className="loading-page__spinner">
          {/* eslint-disable-next-line react/jsx-curly-brace-presence -- must be a literal empty string, not omitted: reactstrap's Spinner defaultProps falls back to children="Loading..." when children is undefined */}
          {''}
        </Spinner>
        {isGeneratingReport ? (
          <div className="loading-page__generate-report">
            <div className="title">Generating report</div>
            <div className="sub-title">This action may take up to 15 minutes.</div>
          </div>
        ) : (
          <div className="loading-page__text">{loadingText}</div>
        )}
      </div>
    </div>
  );
};

export default LoadingPage;
